import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-facebook',
  templateUrl: './facebook.component.html',
  styleUrls: ['./facebook.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FacebookIconComponent {}
